import React from 'react';

const SvgFileSearch = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={48} height={49} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#FileSearch_svg__clip0_1697_4224)">
      <path
        d="M33.429 13.377v-2.571a.43.43 0 00-.429-.428H12.43a.43.43 0 00-.429.428v2.572a.43.43 0 00.429.428H33a.43.43 0 00.429-.428zm-21 4.715a.43.43 0 00-.429.428v2.572a.43.43 0 00.429.428h9.857a.43.43 0 00.429-.428V18.52a.43.43 0 00-.429-.428h-9.857zm7.714 24.214H7.715V4.592h30V23.02a.43.43 0 00.428.429h3a.43.43 0 00.429-.429V2.45c0-.948-.766-1.714-1.715-1.714H5.572c-.949 0-1.715.766-1.715 1.714v42c0 .948.766 1.714 1.715 1.714h14.571a.43.43 0 00.429-.428v-3a.43.43 0 00-.429-.429zm23.877 2.759l-4.998-4.998a9.429 9.429 0 10-2.336 2.186l5.073 5.073a.43.43 0 00.6 0l1.66-1.661a.423.423 0 000-.6zM31.5 40.377c-3.316 0-6-2.683-6-6 0-3.316 2.684-6 6-6s6 2.684 6 6c0 3.317-2.684 6-6 6z"
        fill="#8C8197"
      />
    </g>
    <defs>
      <clipPath id="FileSearch_svg__clip0_1697_4224">
        <path fill="#fff" transform="translate(0 .102)" d="M0 0h48v48H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgFileSearch;
